module.exports = __webpack_public_path__ + "static/media/winter_super_pack_dog_EN.d02586d0.png";